import * as XLSX from 'xlsx';
import type { PaymentOrder } from '../types';
import { bankNameByBin } from './vietqr';

const STATUS_LABEL: Record<string, string> = {
  draft: 'Nháp',
  pending: 'Chờ duyệt',
  approved: 'Đã duyệt',
  rejected: 'Từ chối',
};

// Xuất danh sách lệnh chi ra file .xlsx. Cột số tiền là số thuần (để Excel tính tổng được).
export function exportPaymentOrders(orders: PaymentOrder[], fileBase = 'lenh-chi-da-duyet'): void {
  const rows = orders.map((o, i) => ({
    STT: i + 1,
    'Nhà cung cấp': o.supplierName || '',
    'Số tiền (VND)': o.amount || 0,
    'Ngân hàng': bankNameByBin(o.bankBin),
    'Số tài khoản': o.accountNumber || '',
    'Chủ tài khoản': o.accountHolder || '',
    'Nội dung CK': o.addInfo || '',
    'Trạng thái': STATUS_LABEL[o.status] || o.status,
    'Duyệt lúc': o.approvedAt ? new Date(o.approvedAt).toLocaleString('vi-VN') : '',
    'Tạo lúc': o.createdAt ? new Date(o.createdAt).toLocaleString('vi-VN') : '',
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  ws['!cols'] = [
    { wch: 5 }, { wch: 34 }, { wch: 16 }, { wch: 14 }, { wch: 18 },
    { wch: 26 }, { wch: 28 }, { wch: 12 }, { wch: 20 }, { wch: 20 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Lệnh chi');

  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${fileBase}-${stamp}.xlsx`);
}

// Xuất Excel tổng quát: mảng object -> 1 sheet. Dùng cho nút "Xuất" ở header các trang.
export function exportRows(rows: Record<string, any>[], fileBase: string, sheetName = 'Data'): void {
  const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{}]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `${fileBase}-${stamp}.xlsx`);
}
